import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";

function NtTouchableEffect({
  style,
  children,
  onPress,
  disablePress = false,
  ...otherProps
}) {
  return (
    <TouchableOpacity
      style={[styles.container, style]}
      disabled={disablePress}
      onPress={onPress}
      {...otherProps}
    >
      {children}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtTouchableEffect;
